<mat-expansion-panel hideToggle expanded id="get-in-contact">
    <div class="panel-title">
        <div class="font--headline">{{ I18nKeyEnum.TEST_NOW_TITLE | i18n | async }}</div>
    </div>
    <div *ngIf="!readyToCall">
        <div class="font--bold">{{ I18nKeyEnum.TITLE_MISSING | i18n | async }}</div>
        <div class="flex-r m-bottom-mid m-top-big a-center">
            <div class="reserved-place">
                <mat-icon class="success" [svgIcon]="ICONS.IC_CHECK"
                          [ngClass]="{'hide' : !categoryDone.general}"></mat-icon>
                <div class="not-filled"
                     [ngClass]="{'hide' : categoryDone.general}"></div>
            </div>
            <div class="font--small a-self-center  m-right-mid">{{ I18nKeyEnum.GENERAL_SETTINGS_INFO | i18n | async }}</div>
            <button mat-flat-button class="button-base m-left-auto"
                    (click)="toggleCategory(CategoryEnum.GENERAL)">{{ I18nKeyEnum.OPEN | i18n | async }}
            </button>
        </div>
        <div class="flex-r a-center m-bottom-big">
            <div class="reserved-place">
                <mat-icon class="success" [svgIcon]="ICONS.IC_CHECK"
                          [ngClass]="{'hide' : !categoryDone.knowledgeBase}"></mat-icon>
                <div class="not-filled"
                     [ngClass]="{'hide' : categoryDone.knowledgeBase}"></div>
            </div>
            <div class="font--small a-center a-self-center m-right-mid">{{ I18nKeyEnum.KNOWLEDGE_BASE_INFO | i18n | async }}</div>
            <button mat-flat-button class="button-base m-left-auto"
                    (click)="toggleCategory(CategoryEnum.KNOWLEDGEABLE)">{{ I18nKeyEnum.OPEN | i18n | async }}
            </button>
        </div>
    </div>

    <form class="flex-c" [formGroup]='callbackForm' *ngIf="readyToCall">
        <div class="m-bottom-big font--small-bold">{{ I18nKeyEnum.CALLBACK_NUMBER_INFO | i18n | async }}</div>
        <mat-form-field class="small space-between callback-number">
            <mat-label>{{ I18nKeyEnum.CALLBACK_NUMBER_LABEL | i18n | async }}</mat-label>
            <input [required]="true"
                   [formControl]="callbackNumberCtrl"
                   class="font--small-bold"
                   matInput>
            <mat-error
                    *ngIf="callbackNumberCtrl.hasError(validatorsErrorEnum.REQUIRED)"
            > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
            </mat-error>
        </mat-form-field>
        <mat-label class="m-top-big m-bottom-small font--small-bold" *ngIf="!testCallRunning">{{ I18nKeyEnum.RECEIVE_CALL_NOTE_AS | i18n | async }}</mat-label>
        <div class="flex-c m-left-mid" *ngIf="!testCallRunning">
            <div class="flex-r">
                <div class="flex-r font--small m-right-mid">{{ I18nKeyEnum.RECEIVE_CALL_NOTE_EMAIL | i18n | async }}</div>
                <div class="font--small-bold">{{ email }}</div>
            </div>
            <div class="flex-r">
                <div class="flex-r font-small  m-right-mid">{{ I18nKeyEnum.RECEIVE_CALL_NOTE_WHATSAPP | i18n | async }}</div>
                <div class="font--small-bold">{{ whatsAppNumber }}</div>
            </div>
        </div>
        <button mat-flat-button class="button-base brand-color m-top-big call-btn" type="button"
                (click)="initTestCall()">{{ I18nKeyEnum.CALLBACK_NOW_BTN| i18n | async }}
        </button>
    </form>
</mat-expansion-panel>
